import { render, staticRenderFns } from "./SearhcbarMoreLink.vue?vue&type=template&id=70b2c6a6&scoped=true&"
import script from "./SearhcbarMoreLink.vue?vue&type=script&lang=ts&"
export * from "./SearhcbarMoreLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b2c6a6",
  null
  
)

export default component.exports